<template>
  <v-layout row>
    <v-flex xs12 sm8 offset-sm2 lg4 offset-lg4>
      <v-card>
        <progress-bar :show="form.busy"></progress-bar>
        <form @submit.prevent="register" @keydown="form.onKeydown($event)">
          <v-card-title primary-title>
            <h3 class="headline mb-0">{{ $t('register') }}</h3>
            <h4>{{ $t('register_text') }}</h4>
          </v-card-title>
          <v-card-text>

            <text-input
              :form="form"
              :label="$t('register_form.first_name')"
              :v-errors="errors"
              :value.sync="form.first_name"
              counter="30"
              name="first_name"
              v-validate="'required|max:30'"
            ></text-input>

            <text-input
              :form="form"
              :label="$t('register_form.middle_name')"
              :v-errors="errors"
              :value.sync="form.middle_name"
              name="middle_name"
            ></text-input>

            <text-input
              :form="form"
              :label="$t('register_form.last_name_1')"
              :v-errors="errors"
              :value.sync="form.last_name_1"
              counter="30"
              name="last_name_1"
              v-validate="'required|max:30'"
            ></text-input>

            <text-input
              :form="form"
              :label="$t('register_form.last_name_2')"
              :v-errors="errors"
              :value.sync="form.last_name_2"
              counter="30"
              name="last_name_2"
              v-validate="'required|max:30'"
            ></text-input>

            <select-input
                :form="form"
                :items="nit_types"
                :label="$t('register_form.nit_type')"
                :v-errors="errors"
                :value.sync="form.nit_type"
                name="nit_type"
                v-validate="'required'"
            ></select-input>


            <text-input
              :form="form"
              :label="$t('register_form.nit')"
              :v-errors="errors"
              :value.sync="form.nit"
              counter="15"
              name="nit"
              v-validate="'required|max:30'"
            ></text-input>

            <text-input
              :form="form"
              :label="$t('register_form.phone')"
              :v-errors="errors"
              :value.sync="form.phone"
              counter="10"
              name="phone"
              v-validate="'required|max:30|numeric'"
            ></text-input>

            <text-input
              :form="form"
              :label="$t('register_form.cell_phone')"
              :v-errors="errors"
              :value.sync="form.cell_phone"
              counter="10"
              name="cell_phone"
              v-validate="'required|max:30|numeric'"
            ></text-input>

            <v-autocomplete
                :items="countries"
                :label="$t('register_form.country')"
                v-model="form.country"
                name="country"
                v-validate="'required'"
            ></v-autocomplete>

            <v-autocomplete
                :items="statesToShow"
                :label="$t('register_form.state')"
                v-model="form.state"
                name="state"
                v-validate="'required'"
            ></v-autocomplete>

            <v-autocomplete
                :items="citiesToShow"
                :label="$t('register_form.city')"
                v-model="form.city"
                name="city"
                v-validate="'required'"
            ></v-autocomplete>

            <v-text-field
              :label="$t('register_form.address')"
              v-model="form.address"
              counter="200"
              name="address"
              v-validate="'required|max:200'"
              @focus="showAddressDialog"
              @click="showAddressDialog"
              readonly
            ></v-text-field>


            <date-picker
              :form="form"
              :label="$t('register_form.birth_date')"
              :v-errors="errors"
              :value.sync="form.birth_date"
              name="birth_date"
              v-validate="'required'"
            ></date-picker>

            <select-input
                :form="form"
                :items="locales"
                :label="$t('register_form.locale')"
                :v-errors="errors"
                :value.sync="form.locale"
                name="locale"
                v-validate="'required'"
            ></select-input>

            <!-- Email -->
            <email-input
              :form="form"
              :label="$t('register_form.email')"
              :v-errors="errors"
              :value.sync="form.email"
              name="email"
              v-validate="'required|email'"
            ></email-input>

            <!-- Password -->
            <password-input
              :form="form"
              :hint="$t('password_length_hint')"
              :v-errors="errors"
              :value.sync="form.password"
              v-on:eye="eye = $event"
              v-validate="'required|min:8'"
            ></password-input>

            <!-- Password Confirmation -->
            <password-input
              :form="form"
              :hide="eye"
              :label="$t('confirm_password')"
              :v-errors="errors"
              :value.sync="form.password_confirmation"
              data-vv-as="password"
              hide-icon="true"
              name="password_confirmation"
              v-validate="'required|confirmed:password'"
            ></password-input>

          </v-card-text>

          <v-card-actions>
            <submit-button :form="form" :label="$t('register')"></submit-button>
          </v-card-actions>
        </form>
      </v-card>
    </v-flex>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="490">
        <v-card>
          <v-card-title class="headline success white--text">{{$t('register_ok')}}</v-card-title>
          <v-card-text>
            {{$t('register_verification')}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="goToLogin">{{$t('login')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog v-model="addressDialog" persistent max-width="700px">
        <v-card>
          <v-card-title>
            <span class="headline">{{$t('register_form.address')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout justify-center wrap>
                <v-flex xs12 sm6 md2>
                  <v-autocomplete
                    :items="addressitems"
                    v-model="address_form.det1"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md1>
                  <v-text-field
                    v-model="address_form.det2"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md1>
                  <v-text-field
                    prefix="#"
                    v-model="address_form.det3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md1>
                  <v-text-field
                    prefix="-"
                    v-model="address_form.det4"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-autocomplete
                    :items="addressitems"
                    v-model="address_form.det5"
                    label="Detalle 1"
                    hint="Detalle 1"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field
                    v-model="address_form.det6"
                    label="Detalle 2"
                    hint="Detalle 2"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" flat @click="addressDialog = false">{{$t('close')}}</v-btn>
            <v-btn color="blue darken-1" flat @click="setAddress">Registrarse</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-layout>
</template>

<script>
import Form from 'vform'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'register-view',
  metaInfo () {
    return { title: this.$t('register') }
  },

  data: () => ({
    dialog: false,
    form: new Form({
      name: '',
      first_name: '',
      middle_name: '',
      last_name_1: '',
      last_name_2: '',
      nit_type: '',
      nit: '',
      phone: '',
      cell_phone: '',
      address: '',
      birth_date: '',
      email: '',
      password: '',
      password_confirmation: '',
      username: '',
      locale: 'es',
      country: '169',
      state: '',
      city: '',
    }),
    address_form: new Form({
      det1: 'CL',
      det2: '',
      det3: '',
      det4: '',
      det5: '',
      det6: '',
    }),
    eye: true,
    nit_types: [
      { value: 'CC', text: 'Cedula de ciudadania' },
      { value: 'CE', text: 'Cedula de extranjeria' },

    ],
    locales: [
      { value: 'en', text: 'EN' },
      { value: 'es', text: 'ES' }
    ],
    countries: [],
    states: [],
    cities: [],
    addressDialog: false,
    addressitems: [
      {value: 'AC', text: 'Avenida calle'},
      {value: 'AD', text: 'Administración'},
      {value: 'ADL', text: 'Adelante'},
      {value: 'AER', text: 'Aeropuerto'},
      {value: 'AG', text: 'Agencia'},
      {value: 'AGP', text: 'Agrupación'},
      {value: 'AK', text: 'Avenida carrera'},
      {value: 'AL', text: 'Altillo'},
      {value: 'ALD', text: 'Al lado'},
      {value: 'ALM', text: 'Almacén'},
      {value: 'AP', text: 'Apartamento'},
      {value: 'APTDO', text: 'Apartado'},
      {value: 'ATR', text: 'Atrás'},
      {value: 'AUT', text: 'Autopista'},
      {value: 'AV', text: 'Avenida'},
      {value: 'AVIAL', text: 'Anillo vial'},
      {value: 'BG', text: 'Bodega'},
      {value: 'BL', text: 'Bloque'},
      {value: 'BLV', text: 'Boulevard'},
      {value: 'BRR', text: 'Barrio C Corregimiento'},
      {value: 'CA', text: 'Casa'},
      {value: 'CAS', text: 'Caserío'},
      {value: 'CC', text: 'Centro comercial'},
      {value: 'CD', text: 'Ciudadela'},
      {value: 'CEL', text: 'Célula'},
      {value: 'CEN', text: 'Centro'},
      {value: 'CIR', text: 'Circular'},
      {value: 'CL', text: 'Calle', selected: true},
      {value: 'CLJ', text: 'Callejón'},
      {value: 'CN', text: 'Camino'},
      {value: 'CON', text: 'Conjunto residencial'},
      {value: 'CONJ', text: 'Conjunto'},
      {value: 'CR', text: 'Carrera'},
      {value: 'CR', text: 'T Carretera'},
      {value: 'CRV', text: 'Circunvalar'},
      {value: 'CS', text: 'Consultorio'},
      {value: 'DG', text: 'Diagonal'},
      {value: 'DP', text: 'Depósito'},
      {value: 'DPTO', text: 'Departamento'},
      {value: 'DS', text: 'Depósito sótano'},
      {value: 'ED', text: 'Edificio'},
      {value: 'EN', text: 'Entrada'},
      {value: 'ES', text: 'Escalera'},
      {value: 'ESQ', text: 'Esquina'},
      {value: 'ESTE', text: 'Este'},
      {value: 'ET', text: 'Etapa'},
      {value: 'EX', text: 'Exterior'},
      {value: 'FCA', text: 'Finca'},
      {value: 'GJ', text: 'Garaje'},
      {value: 'GS', text: 'Garaje sótano'},
      {value: 'GT', text: 'Glorieta'},
      {value: 'HC', text: 'Hacienda'},
      {value: 'HG', text: 'Hangar'},
      {value: 'IN', text: 'Interior'},
      {value: 'IP', text: 'Inspección de Policía'},
      {value: 'IPD', text: 'Inspección Departamental'},
      {value: 'IPM', text: 'Inspección Municipal'},
      {value: 'KM', text: 'Kilómetro'},
      {value: 'LC', text: 'Local'},
      {value: 'LM', text: 'Local mezzanine'},
      {value: 'LT', text: 'Lote'},
      {value: 'MD', text: 'Módulo'},
      {value: 'MJ', text: 'Mojón'},
      {value: 'MLL', text: 'Muelle'},
      {value: 'MN', text: 'Mezzanine'},
      {value: 'MZ', text: 'Manzana'},
      {value: 'NOMBRE', text: 'VIA Vías de nombre común'},
      {value: 'NORTE', text: 'Norte O Oriente'},
      {value: 'OCC', text: 'Occidente'},
      {value: 'OESTE', text: 'Oeste'},
      {value: 'OF', text: 'Oficina P Piso'},
      {value: 'PA', text: 'Parcela'},
      {value: 'PAR', text: 'Parque'},
      {value: 'PD', text: 'Predio'},
      {value: 'PH', text: 'Penthouse'},
      {value: 'PJ', text: 'Pasaje'},
      {value: 'PL', text: 'Planta'},
      {value: 'PN', text: 'Puente'},
      {value: 'POR', text: 'Portería'},
      {value: 'POS', text: 'Poste'},
      {value: 'PQ', text: 'Parqueadero'},
      {value: 'PRJ', text: 'Paraje'},
      {value: 'PS', text: 'Paseo'},
      {value: 'PT', text: 'Puesto'},
      {value: 'PW', text: 'Park Way'},
      {value: 'RP', text: 'Round Point'},
      {value: 'SA', text: 'Salón'},
      {value: 'SC', text: 'Salón comunal'},
      {value: 'SD', text: 'Salida'},
      {value: 'SEC', text: 'Sector'},
      {value: 'SL', text: 'Solar'},
      {value: 'SM', text: 'Súper manzana'},
      {value: 'SS', text: 'Semisótano'},
      {value: 'ST', text: 'Sótano'},
      {value: 'SUITE', text: 'Suite'},
      {value: 'SUR', text: 'Sur'},
      {value: 'TER', text: 'Terminal'},
      {value: 'TERPLN', text: 'Terraplén'},
      {value: 'TO', text: 'Torre'},
      {value: 'TV', text: 'Transversal'},
      {value: 'TZ', text: 'Terraza'},
      {value: 'UN', text: 'Unidad'},
      {value: 'UR', text: 'Unidad residencial'},
      {value: 'URB', text: 'Urbanización'},
      {value: 'VRD', text: 'Vereda'},
      {value: 'VTE', text: 'Variante'},
      {value: 'ZF', text: 'Zona franca'},
      {value: 'ZN', text: 'Zona'},
    ]
  }),

  created () {
    this.form.locale = this.locale;
    this.init()
  },

  computed: {
    ...mapGetters({
      locale: 'locale'
    }),
    statesToShow() {
      return this.states.filter(state => state.id_pais === this.form.country)
    },
    citiesToShow() {
      return this.cities.filter(city => city.id_departamento === this.form.state)
    },
  },

  watch: {
    locale(newValue, oldValue) {
      this.form.locale = newValue
    },
  },

  methods: {
    init() {
      axios.get('/api/countries')
        .then(resp => {
          if (resp.status === 200) {
            this.countries = resp.data.countries
          }
        })
        .catch(error => console.log(error))

      axios.get('/api/states')
        .then(resp => {
          if (resp.status === 200) {
            this.states = resp.data.states
          }
        })
        .catch(error => console.log(error))

      axios.get('/api/cities')
        .then(resp => {
          if (resp.status === 200) {
            this.cities = resp.data.cities
          }
        })
        .catch(error => console.log(error))
    },
    showAddressDialog() {
      this.addressDialog = true
    },
    setAddress() {
      const address = [
        this.address_form.det1,
        this.address_form.det2,
        this.address_form.det3,
        this.address_form.det4,
        this.address_form.det5,
        this.address_form.det6,
      ].map(det => det.trim())
      .join(' ')
      this.form.address = address
      this.addressDialog = false
    },
    async register () {
      if (await this.formHasErrors()) return

      this.form.name = `${this.form.first_name} ${this.form.middle_name} ${this.form.last_name_1} ${this.form.last_name_2}`;
      this.form.username = this.form.nit
      // Register the user.
      this.form.post('/api/register')
        .then(resp => {
          this.dialog = true
        })
        .catch(err => {
          console.log(err.response)
          if (err.response.status === 422) {
            this.$store.dispatch('responseMessage', {
              type: 'warning',
              text: 'El número de identificación o el correo electrónico ingresados ya se encuenran registrados.',
              title: 'Error al crear usuario',
              modal: true
            })
          }
        })
    },
    goToLogin() {
      this.$router.push({ name: 'login' })
      this.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/register.vue